/* global Image */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import posed from 'react-pose';
import {Link, graphql} from 'gatsby';
import Img from 'gatsby-image';

import objectives from '../libs/objectives';

import styles from './index.module.css';

const easeIn = [0.4, 0.0, 1, 1];
const easeOut = [0.0, 0.0, 0.2, 1];

const drop = {
    preEnter: {
        y: 75,
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            ease: easeOut,
        },
    },
    exit: {
        y: 75,
        opacity: 0,
        transition: {
            ease: easeIn,
        },
    },
};

const Content = posed.div({
    preEnter: {
        y: 0,
        opacity: 0,
    },
    enter: {
        opacity: 1,
        transition: {
            duration: 0,
        },
        beforeChildren: true,
        delay: 600,
        staggerChildren: 100,
        staggerDirection: -1,
    },
    exit: {
        staggerChildren: 100,
        staggerDirection: -1,
        transition: {
            duration: 800,
        },
    },
});

const Header = posed.h1(drop);
const Subhed = posed.p(drop);
const Drop = posed.div(drop);
const Fade = posed.div({
    preEnter: {
        opacity: 0,
    },
    enter: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 400,
            ease: easeOut,
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 200,
            ease: easeIn,
        },
    },
});

class IndexPage extends Component {
    static propTypes = {
        data: PropTypes.objectOf(PropTypes.object).isRequired,
        location: PropTypes.objectOf(PropTypes.any).isRequired,
        hostRef: PropTypes.func.isRequired,
    };

    componentDidMount() {
        // preload first step image
        const preload = new Image();
        preload.src = objectives.start.image;
    }

    render() {
        const {hostRef, location, data} = this.props;

        return (
            <div ref={hostRef} key={location.key}>
                <Content className={styles.container} key="content">
                    <Fade key="dots" className={styles.dots} />
                    <div key="head" className={styles.head}>
                        <div className={styles.content}>
                            <Header key="header">We're here to help you plan the perfect smart home.</Header>
                            <Subhed key="subhed">
                                Amazon connected security unlocks the power of anywhere-anytime
                                access to your connected house, putting dynamic and easy-to-use
                                options — from switching the lights on from your office to turning
                                up the thermostat to unlocking the back door — all in the palm of
                                your hand.
                            </Subhed>
                            <Drop key="start">
                                <Link to="/questions" className={styles.getStarted}>
                                    <span>Get Started</span>
                                    <div className={styles.arrow}>
                                        <svg width="37" height="32" xmlns="http://www.w3.org/2000/svg">
                                            <g fillRule="nonzero">
                                                <path d="M20.608 1.068L21.683.022l15.31 15.723-15.31 15.723-1.075-1.046 14.29-14.677z" />
                                                <path d="M35.4 15v1.5H.2V15z" />
                                            </g>
                                        </svg>
                                    </div>
                                </Link>
                            </Drop>
                        </div>
                        <Drop key="image" className={styles.imageWrap}>
                            <Img fluid={data.file.childImageSharp.fluid} className={styles.image} />
                        </Drop>
                    </div>
                    <Drop key="sidebar" className={styles.sidebar}>
                        <div className={styles.tags}>
                            <span>Smart.</span>
                            <span>Safe.</span>
                            <span>Secure.</span>
                        </div>
                    </Drop>
                </Content>
            </div>
        );
    }
}

export const query = graphql`
    query {
        file(relativePath: { eq: "welcome.jpg" }) {
            childImageSharp {
                fluid(maxHeight: 500) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`;

export default posed(IndexPage)();
